import { useState, Dispatch, SetStateAction } from 'react';

export function useWizardStepData<T>(
  initialData: T,
  onDataChange: (data: T) => void
): [T, Dispatch<SetStateAction<T>>] {
  const [data, setDataState] = useState<T>(initialData);

  const setData = (d: ((s: T) => T) | T) => {
    setDataState((current: T) => {
      const newData: T = typeof d === 'function' ? (d as (s: T) => T)(current) : d;
      onDataChange(newData);

      return newData;
    });
  };

  return [data, setData];
}
